import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationListComponent } from 'src/app/public-utility/organization/components/organization-list/organization-list.component';
import { FlexModule } from '@angular/flex-layout';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [OrganizationListComponent],
  exports: [OrganizationListComponent],
  imports: [
    CommonModule,
    FlexModule,
    MatTableModule,
    MatButtonModule,
    MatChipsModule,
    MatMenuModule,
    MatIconModule,
    RouterModule,
    MatDialogModule,
    MatCardModule,
    MatInputModule,
    FormsModule,
    MatSelectModule,
  ],
})
export class OrganizationListModule {}
